import React from 'react';
import { GraduationCap, Clock, Heart, Home } from 'lucide-react';

const About: React.FC = () => {
  return (
    <section id="sobre" className="py-16 px-6 sm:px-8 md:py-20 lg:py-24 bg-green-100">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Imagem/Placeholder */}
          <div className="relative animate-fade-in hidden md:block">
            <div className="aspect-[4/5] rounded-2xl shadow-xl overflow-hidden">
              <img 
                src="/img2.jpeg"
                alt="Fisioterapia RPG e Pilates zona sul São Paulo - Dra. Katia Honda especialista em reabilitação músculo-esquelética"
                className="w-full h-full object-cover"
              />
            </div>
            
            {/* Elementos decorativos */}
            <div className="absolute -top-6 -right-6 w-20 h-20 bg-accent-200 rounded-full opacity-60"></div>
            <div className="absolute -bottom-6 -left-6 w-16 h-16 bg-secondary-200 rounded-full opacity-60"></div>
          </div>

          {/* Conteúdo */}
          <div className="space-y-8 sm:space-y-10 animate-slide-up">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-6 sm:mb-8">
                Sobre a Dra. Katia Honda
              </h2>
            </div>

            {/* Descrição profissional */}
            <div className="space-y-5 sm:space-y-6">
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Fisioterapeuta com foco em reabilitação músculo-esquelética e pilates clássico.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Minha atuação é voltada para ajudar pessoas a se recuperarem de dores e lesões, 
                como <strong>tendinopatias, epicondilites, fascite plantar, lesões musculares, 
                entorses e DTM</strong>, além de oferecer <strong>Pilates</strong> para fortalecimento e reabilitação, 
                sempre com uma abordagem individual e personalizada.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Acredito que <strong>quanto antes iniciar o tratamento, maiores são as chances 
                de recuperar a mobilidade e evitar complicações</strong>. Por isso, ofereço 
                atendimento personalizado no conforto da sua casa, eliminando barreiras e 
                proporcionando maior comodidade aos meus pacientes.
              </p>
            </div>

            {/* Formação Profissional */}
            <div className="border-l-4 border-primary-500 pl-4 sm:pl-6 py-2">
              <div className="flex items-center space-x-3 mb-4">
                <GraduationCap className="w-5 h-5 text-primary-500" />
                <h3 className="text-base sm:text-lg font-semibold text-gray-900">Formação Profissional</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-xs sm:text-sm text-gray-700 leading-relaxed">Graduada em Fisioterapia pela Universidade Paulista - UNIP</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-xs sm:text-sm text-gray-700 leading-relaxed">Pós-Graduada em Reabilitação Musculoesquelética pelo Centro Universitário São Camilo</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-xs sm:text-sm text-gray-700 leading-relaxed">Instrutora de Pilates Clássico - Voll Group</span>
                </li>
              </ul>
            </div>

            {/* Linha divisória */}
            <div className="border-t border-gray-200 my-8 sm:my-10"></div>

            {/* Diferenciais */}
            <div className="grid grid-cols-1 gap-6 sm:gap-8 md:grid-cols-2">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Heart className="w-6 h-6 text-primary-500" />
                </div>
                <div>
                  <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-2">Cuidado Personalizado</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">Cada tratamento é adaptado às necessidades específicas do paciente</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-primary-500" />
                </div>
                <div>
                  <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-2">Horários Convenientes</h3>
                  <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">Atendimento de segunda à sexta, das 15h às 19h</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4 md:col-span-2">
                <div className="w-12 h-12 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Home className="w-6 h-6 text-primary-500" />
                </div>
                <div>
                  <h3 className="text-sm sm:text-base font-semibold text-gray-900 mb-2">Atendimento Domiciliar</h3>
                  <p className="text-xs sm:text-sm text-gray-600 mb-3 leading-relaxed">Tratamento no conforto e segurança da sua casa.</p>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    <strong>Zona Sul de São Paulo:</strong> Jabaquara, São Judas, Conceição, Saúde, Vila Mariana e regiões próximas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;